import { createGlobalStyle } from 'styled-components';
import { WithThemeProps, defaultTheme } from './theme';


const GlobalStyle = createGlobalStyle`
	html {
		font-size: ${defaultTheme.typography.baseFontSize}px;
		color: ${defaultTheme.color.blackPrimary};

		${(p: WithThemeProps) => p.theme && `
			font-size: ${p.theme.typography.baseFontSize}px;
			color: ${p.theme.color.blackPrimary};
		`};
	}

	body {
		${defaultTheme.typography.body.styled}
		background-color: ${defaultTheme.color.bgLight};

		${(p: WithThemeProps) => p.theme && `
			${p.theme.typography.body.styled}
			background-color: ${p.theme.color.bgLight};
		`};
	}

	body .MuiBackdrop-root {
		background-color: rgba(62, 71, 87, 0.7);
	}
`;

export {
	GlobalStyle
}